import React, { useCallback } from 'react';
import demosData from '../data/javascripts/demosData';
import { useNavigate } from 'react-router-dom';
import DemoCard from '../widgets/DemoCard'; // The specific card component
import HorizontalCardDeck from '../widgets/HorizontalCardDeck';
import ActionButton from '../widgets/ActionButton';

const Demos = () => {
    const navigate = useNavigate();
    
    // Define the click handler needed by the specific card type
    const handleDemoClick = useCallback(
        path => navigate(`/demos/${path}`, { state: { fromDemos: true } }),
        [navigate]
    );

    // Define the renderer function to pass to the generic component
    // This function takes an item and returns the JSX for the card.
    const renderDemoItem = useCallback((demo) => {
        // 'cardWidth' is now available inside the HorizontalCardDeck, 
        // so we pass the specific props needed for DemoCard.
        // HorizontalCardDeck will automatically apply the width styling via the wrapper.
        return (
            <DemoCard
                demo={demo}
                onClick={handleDemoClick}
                // Note: If DemoCard needs cardWidth internally, HorizontalCardDeck needs 
                // to pass it explicitly in its wrapper. Since we removed the renderCard 
                // wrapper logic from the parent, we assume the component is styled via the wrapper.
                // If DemoCard must know cardWidth, you must adjust HorizontalCardDeck's RenderCardWrapper
                // to pass it via props. We will rely on the generic deck component for width styling.
            />
        );
    }, [handleDemoClick]);

    return (
        <section id="demos" className="bg-bg-light dark:bg-bg-dark">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                    <h2 className="section-heading text-primary dark:text-secondary">
                        Recent Demos
                    </h2>
                </div>

                {/* --- Using the Generic HorizontalCardDeck --- */}
                <HorizontalCardDeck 
                    items={demosData} // The data array
                    renderItem={renderDemoItem} // The function that returns the DemoCard JSX
                    rows={1} // Set rows for large screens
                />

                <div className="text-center mt-12">
                    <ActionButton 
                        text="View All Demos" 
                        onClick={() => navigate('/demos')} 
                        className="btn-md"
                    />
                </div>
            </div>
        </section>
    );
};

export default React.memo(Demos);